var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listCount > 0)?_c('nav',[_c('b-pagination',{attrs:{"size":"sm","prev-text":_vm.$t('PREV'),"next-text":_vm.$t('NEXT'),"total-rows":_vm.listCount,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }